import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <TopicsSection />
        <IndexSection />
        <CardsSection />
        <MediaSection />
        <CommentsSection />
        <CarouselSection />
        <AppSection />
        <RankingSection />
        <FeaturesSection />
        <UpdatesSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}